import { action, computed, makeObservable, observable } from 'mobx'

export interface SelectedCreator {
  id: string
  name: string
  picture?: string
}

let instance: CampaignInviteStore

// Store de la feature "Inviter a une campagne".
// - selection multi-createurs depuis la galerie (persiste pendant le scroll)
// - ouverture de la modale d'invitation (depuis la barre galerie ou la fiche
//   createur en single)
export class CampaignInviteStore {
  constructor() {
    if (instance) {
      makeObservable(instance)
      return instance
    }
    instance = this
    makeObservable(instance)
  }

  @observable selected: Map<string, SelectedCreator> = new Map()

  @observable isModalOpen: boolean = false

  // Compteur incremente apres chaque envoi/achat : sert de signal aux badges de
  // solde (galerie, messagerie) pour se rafraichir sans recharger la page.
  @observable balanceVersion: number = 0

  @action.bound
  refreshBalance() {
    this.balanceVersion++
  }

  @computed get count(): number {
    return this.selected.size
  }

  @computed get creators(): SelectedCreator[] {
    return Array.from(this.selected.values())
  }

  isSelected(id: string): boolean {
    return this.selected.has(id)
  }

  @action.bound
  toggle(creator: SelectedCreator) {
    if (this.selected.has(creator.id)) this.selected.delete(creator.id)
    else this.selected.set(creator.id, creator)
  }

  @action.bound
  add(creator: SelectedCreator) {
    this.selected.set(creator.id, creator)
  }

  @action.bound
  remove(id: string) {
    this.selected.delete(id)
  }

  @action.bound
  clear() {
    this.selected.clear()
  }

  // Ouvre la modale avec la selection courante (barre galerie).
  @action.bound
  openModal() {
    if (this.selected.size === 0) return
    this.isModalOpen = true
  }

  // Ouvre la modale pour UN createur (fiche createur). On remplace la selection
  // par ce seul createur pour rester coherent avec l'affichage de la modale.
  @action.bound
  openSingle(creator: SelectedCreator) {
    this.selected.clear()
    this.selected.set(creator.id, creator)
    this.isModalOpen = true
  }

  @action.bound
  closeModal() {
    this.isModalOpen = false
  }
}

const campaignInviteStore = new CampaignInviteStore()
export default campaignInviteStore
